// view/stepsecond.jsx (แก้เฉพาะส่วนล่าง: ลบส่วนตั้งแต่ <Divider /> ที่เป็นนัดหมายออก)
import React, { useEffect, useState } from 'react';
import { Row, Col, Divider, Grid } from 'antd';
import { TextCustom, TextHeadTitle } from '../../../components/text';
import { convertStrToFormat } from '../../../functions';
import { color } from '../../../resources';
import { GUTTER_LAYOUT } from '../../../resources';
import { NotBuyingModal } from '../modal';
import appleIcon from '../../../assets/images/logo-text.png';

export const StepSecond = ({ data }) => {
  const { detail, estimation } = data;
  const screens = Grid.useBreakpoint();
  const [notBuyingOpen, setNotBuyingOpen] = useState(false);

  useEffect(() => {
    // show NotBuyingModal when finalPrice is negative
    if (estimation?.finalPrice <= 0) {
      setNotBuyingOpen(true);
    } else {
      setNotBuyingOpen(false);
    }
  }, [estimation?.finalPrice]);
  return (
    <div>
      <TextHeadTitle text={'สรุปราคาประเมินการรับซื้อ'} bold />
      <Row
        gutter={GUTTER_LAYOUT?.MAIN_CONTENT}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {/* <Col {...BREAKE_POINT?.OTHER_COUTENT_FOUR} style={{ textAlign: 'center' }}>
   
          <TextCustom size={'32px'} text={estimation?.name} bold></TextCustom>
        </Col> */}

        <Col style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Row gutter={[16, 16]} align="top" style={{ width: '100%' }}>
            {/* ซ้าย: ราคาประเมิน/โปร/สุทธิ + คำเตือน */}
            <Col xs={24} md={12}>
              {notBuyingOpen ? (
                <div style={{ textAlign: 'center' }}>
                  {/* icon above the message */}
                  <div style={{ width: '100px', margin: '0 auto', textAlign: 'center' }}>
                    <img
                      src={appleIcon}
                      alt="apple icon"
                      style={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        margin: '0 auto 12px',
                      }}
                    />
                  </div>
                  <TextCustom
                    text={'เราไม่สามารถรับซื้อสินค้าของคุณได้'}
                    size={'24px'}
                    color={color.black_grey}
                  />
                  <TextCustom
                    text={
                      'หากมีข้อสงสัยเพิ่มเติม กรุณาติดต่อแอดมิน LineOA: @applehouseth (มี@ด้านหน้า)'
                    }
                    size={'24px'}
                    color={color.black_grey}
                  />
                </div>
              ) : (
                <>
                  <TextCustom
                    size={'32px'}
                    text={estimation?.name}
                    bold
                    style={{ display: 'flex', justifyContent: 'center' }}
                  ></TextCustom>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span className="text-title">ราคาประเมิน</span>
                    <span
                      className="text-detail"
                      style={{ display: 'flex', alignItems: 'center', color: '#8D8D8D' }}
                    >
                      {estimation?.promotion !== 0 && estimation?.promotion != null
                        ? estimation?.finalPrice > 0
                          ? convertStrToFormat(estimation?.estimateprice, 'money')
                          : 'ไม่รับซื้อ'
                        : estimation?.finalPrice > 0
                          ? convertStrToFormat(estimation?.finalPrice, 'money')
                          : 'ไม่รับซื้อ'}
                      <span style={{ fontSize: '20px', marginLeft: '4px' }}>บาท</span>
                    </span>
                  </div>

                  {estimation?.promotion !== 0 && estimation?.promotion != null && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span className="text-title">ราคาโปรโมชั่น</span>
                      <span
                        className="text-detail"
                        style={{ display: 'flex', alignItems: 'center', color: '#45b4a8' }}
                      >
                        + {convertStrToFormat('+' + estimation?.promotion, 'money')}
                        <span style={{ fontSize: '20px', marginLeft: '4px' }}>บาท</span>
                      </span>
                    </div>
                  )}

                  <hr style={{ margin: '8px 0' }} />

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span className="text-title-price">ราคาสุทธิ</span>
                    <span
                      className="text-detail-price"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      {estimation?.finalPrice > 0
                        ? convertStrToFormat(estimation?.finalPrice + 0, 'money')
                        : 'ไม่รับซื้อ'}
                      <span style={{ fontSize: '20px', marginLeft: '4px' }}>บาท</span>
                    </span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <TextCustom
                      text={'ด่วน! ทำนัดเข้าขายราคานี้ได้'}
                      size={'24px'}
                      color={'red'}
                      align="center"
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                    <TextCustom
                      text={'ภายใน 7 วันเท่านั้น*'}
                      size={'24px'}
                      color={'red'}
                      align="center"
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <TextCustom
                      text={' (*ราคาที่แจ้งเป็นราคาประเมินเบื้องต้น'}
                      size={'18px'}
                      align="center"
                      color={'black'}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                    <TextCustom
                      text={
                        'โดยเครื่องจะต้องมีสภาพสมบูรณ์ตามประเมินไว้หากเครื่องไม่เป็นไปตามที่แจ้ง'
                      }
                      size={'18px'}
                      color={'black'}
                      align="center"
                    />
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                    <TextCustom
                      text={
                        ' จะต้องทำการประเมินใหม่ อ้างอิงราคาตามเรทที่ดีที่สุด ณ วันที่เข้าขายเท่านั้น)'
                      }
                      size={'18px'}
                      color={'black'}
                      align="center"
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '10px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <TextCustom
                      text={'กดปุ่มรับสิทธิ์ด้านล่าง ก่อนปรับราคาลง'}
                      size={'24px'}
                      color={color.theme}
                      align="center"
                      bold
                    />
                  </div>
                </>
              )}
            </Col>
            <Col xs={0} md={1}></Col>
            {/* ขวา (เฉพาะ PC): รายละเอียด */}
            <Col xs={24} md={11}>
              <Divider style={{ display: screens.md ? 'none' : 'block' }} />

              {/* ใช้กริด 2 คอลัมน์ แล้วสั่งให้ชิดขวาเฉพาะ PC */}
              <div className="detail-grid" style={{ width: '100%' }}>
                {detail.map((el, i) => (
                  <React.Fragment key={`row_detail_${i}`}>
                    <span className="text-title">{el.title}</span>
                    <span className="text-detail">{el.description ?? '-'}</span>
                  </React.Fragment>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <NotBuyingModal open={notBuyingOpen} onToggle={() => setNotBuyingOpen(false)} />
    </div>
  );
};
